export default {
      id: "ar_urbanisme-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ar_urbanisme-usage",
      toString: function () {
        return this.url;
      }
    }